module.exports = __webpack_public_path__ + "img/of.7dc28c95.png";